module.exports = __webpack_public_path__ + "img/agrosem.6fd1872c.webp";